import * as Preact from 'preact'
import * as styles from './index.css'
import { bem } from '@nrk/dh-utils'
import PureComponent from '../../../lib/preact-pure-component'

const { h } = Preact

interface IFadeInProps {
  class?: string
  [key: string]: any
}

class FadeIn extends PureComponent<IFadeInProps, {}> {
  public render() {
    const attributes: { [key: string]: any } = {}
    if (this.props.loaded !== undefined) {
      const ownClasses = bem(styles['fade-in'], {
        'not-loaded': !this.props.loaded
      })
      attributes.class = `${ownClasses} ${this.props.class || ''}`
    } else {
      attributes.class = `${styles['fade-in']} ${this.props.class || ''}`
    }

    if (this.props.delay !== undefined) {
      attributes.style = { animationDelay: this.props.delay }
    }

    return h(this.props.tag || 'div', attributes, this.props.children)
  }
}

export { FadeIn }
